import {LOADING_ACTIONS} from '../../constants/loading';

export function ActionLoadingUpdate(ns, payload) {
  const data = {};
  data[ns] = payload;

  return {
    type: LOADING_ACTIONS.LOADING_UPDATE,
    data,
  };
}
